import { mapLink } from '@websrc/DataMappers/mapLink'
import { CSLocales } from '@websrc/Typings/ContentStack'

export function getAnchorPropsFromLink(link: ReturnType<typeof mapLink>, locale: CSLocales) {
  const anchorProps: Partial<Pick<HTMLAnchorElement, 'href' | 'rel' | 'target'>> = {}

  // Always prefer internal links
  if (link.internal_link?.length && link.internal_link[0].url) {
    const url = link.internal_link[0].url
    const urlWithStartingSlash = url.startsWith(`/`) ? url : `/${url}`

    anchorProps.href = url.startsWith(`/${locale}`) ? url : `/${locale}${urlWithStartingSlash}`
  }
  // If file link, go for that.
  else if (link.file_link) {
    anchorProps.href = link.file_link.url
  }
  // If external
  else if (link.external_link) {
    anchorProps.href = link.external_link
  }

  if (link.file_link || link.open_in_new_tab) {
    anchorProps.target = '_blank'
    anchorProps.rel = 'noreferrer noopener'
  }

  return anchorProps
}
